import { render } from "./NavigationMenu.vue?vue&type=template&id=5ed186d7&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=5ed186d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ed186d7"

export default script